export const GET_ALL_IMAGES_FOR_PROCESSING_REQUEST =
  'GET_ALL_IMAGES_FOR_PROCESSING_REQUEST';
export const GET_ALL_IMAGES_FOR_PROCESSING_SUCCESS =
  'GET_ALL_IMAGES_FOR_PROCESSING_SUCCESS';
export const GET_ALL_IMAGES_FOR_PROCESSING_FAILED =
  'GET_ALL_IMAGES_FOR_PROCESSING_FAILED';
export const GET_ALL_IMAGES_FOR_PROCESSING_CLEAR =
  'GET_ALL_IMAGES_FOR_PROCESSING_CLEAR';

export const SAVE_MULTIPLE_IMAGES_STATUS_REQUEST =
  'SAVE_MULTIPLE_IMAGES_STATUS_REQUEST';
export const SAVE_MULTIPLE_IMAGES_STATUS_SUCCESS =
  'SAVE_MULTIPLE_IMAGES_STATUS_SUCCESS';
export const SAVE_MULTIPLE_IMAGES_STATUS_FAILED =
  'SAVE_MULTIPLE_IMAGES_STATUS_FAILED';
export const SAVE_MULTIPLE_IMAGES_STATUS_CLEAR =
  'SAVE_MULTIPLE_IMAGES_STATUS_CLEAR';

export const SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_REQUEST =
  'SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_REQUEST';
export const SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_SUCCESS =
  'SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_SUCCESS';
export const SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_FAILED =
  'SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_FAILED';
export const SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_CLEAR =
  'SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_CLEAR';

export const CHANGE_GROUP_IMAGES_WORK_DATA = 'CHANGE_GROUP_IMAGES_WORK_DATA';
export const CHANGE_RESERVED_IDS_DATA = 'CHANGE_RESERVED_IDS_DATA';
export const SET_IMAGE_GROUP_COUNT = 'SET_IMAGE_GROUP_COUNT';
export const SET_IMAGE_WORKING_IDS = 'SET_IMAGE_WORKING_IDS';
